export default __webpack_public_path__ + "static/media/logofedpa.b2dae939.svg";